/* eslint-disable css-modules/no-undef-class */
import { useI18n } from '@/libraries/contexts/i18n-context';
import Typography from '@/components/atoms/typography/typography';
import StepIndicator from '@/components/molecules/step-indicator/step-indicator';
import styles from './inspirational-search-flow-step-indicator.module.scss';

export interface InspirationalSearchFlowStepIndicatorProps {
  /** The currently active step */
  currentStep?: number;
  /** The total step count */
  stepCount?: number;
}

const InspirationalSearchFlowStepIndicator = ({
  currentStep = 1,
  stepCount = 0,
}: InspirationalSearchFlowStepIndicatorProps) => {
  const { t } = useI18n();

  if (stepCount < 2) return;

  return (
    <div className={styles.component}>
      <Typography className={styles.preHeadline} tagStyle="labelMedium">
        {t('items.inspirationalSearch.stepNumberOfTotal', {
          current: currentStep,
          total: stepCount,
        })}
      </Typography>

      <StepIndicator currentItem={currentStep} filled itemCount={stepCount} />
    </div>
  );
};

InspirationalSearchFlowStepIndicator.displayName =
  'InspirationalSearchFlowStepIndicator';

export default InspirationalSearchFlowStepIndicator;
